import styles from './TurnOrderBadge.module.css';

interface TurnOrderBadgeProps {
  // Display name of whoever currently holds the turn, when we can resolve it.
  // Falls back to a generic message when null.
  currentHolderName?: string | null;
}

// Hot Seat (campfire_circle) gates contributions on whose turn it is. The PWA
// has no way to advance the order today (turnOrder is seeded only from the
// creator at thread create — see plan, §Out of scope), so we surface a clear
// blocking message rather than a failing Post button.
export function TurnOrderBadge({ currentHolderName }: TurnOrderBadgeProps) {
  return (
    <div class={styles.badge} role="status">
      <strong class={styles.title}>It’s not your turn yet</strong>
      <p class={styles.body}>
        {currentHolderName
          ? `Waiting for ${currentHolderName} to take the seat.`
          : 'Hot Seat passes the mic one voice at a time.'}{' '}
        Hot Seat threads aren’t fully supported in the browser yet — open OurTake on iOS to take your turn.
      </p>
    </div>
  );
}
